<template>
	<div class="main-content" :style='{"color":"#666","padding":"20px 30px 30px","fontSize":"16px"}'>
		<!-- 列表页 -->
		<template v-if="showFlag">
			<el-form class="center-form-pv" :style='{"margin":"0 0 20px","fontSize":"inherit"}' :inline="true" :model="searchForm">
				<el-row :style='{"fontSize":"inherit","display":"block"}' >
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}'>
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">工号</label>
						<el-input v-model="searchForm.gonghao" placeholder="工号" @keydown.enter.native="search()" clearable></el-input>
					</div>
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}'>
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">姓名</label>
						<el-input v-model="searchForm.xingming" placeholder="姓名" @keydown.enter.native="search()" clearable></el-input>
					</div>
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}'>
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">测评结果</label>
						<el-input v-model="searchForm.resultType" placeholder="测评结果类型" @keydown.enter.native="search()" clearable></el-input>
					</div>
					<el-button class="search" type="success" @click="search()">
						<span class="icon iconfont icon-yanziwancheng" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						搜索
					</el-button>
				</el-row>

				<el-row class="actions" :style='{"flexWrap":"wrap","margin":"20px 0","display":"flex"}'>
					<el-button class="del" v-if="isAuth('cepingJieguo','删除')" :disabled="dataListSelections.length?false:true" type="danger" @click="deleteHandler()">
						<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						删除
					</el-button>
				</el-row>
			</el-form>
			<div :style='{"width":"100%","padding":"0","background":"none"}'>
				<el-table class="tables"
					:stripe='false'
					:style='{"padding":"0","borderColor":"#eee","color":"inherit","borderWidth":"1px 0 0 1px","background":"#fff","width":"100%","fontSize":"inherit","borderStyle":"solid"}' 
					:border='true'
					v-if="isAuth('cepingJieguo','查看')"
					:data="dataList"
					v-loading="dataListLoading"
				@selection-change="selectionChangeHandler">
					<el-table-column :resizable='true' type="selection" align="center" width="50"></el-table-column>
					<el-table-column :resizable='true' :sortable='true' label="序号" type="index" width="50" />
					<el-table-column :resizable='true' :sortable='true'  
						prop="gonghao"
						label="工号">
						<template slot-scope="scope">
							{{scope.row.gonghao}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="xingming"
						label="姓名">
						<template slot-scope="scope">
							{{scope.row.xingming}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="shouji"
						label="手机">
						<template slot-scope="scope">
							{{scope.row.shouji}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="aCount"
						label="A选项">
						<template slot-scope="scope">
							{{scope.row.aCount}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="bCount"
						label="B选项">
						<template slot-scope="scope">
							{{scope.row.bCount}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="cCount"
						label="C选项">
						<template slot-scope="scope">
							{{scope.row.cCount}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="resultType"
						label="测评结果">
						<template slot-scope="scope">
							{{scope.row.resultType}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true'  
						prop="addtime"
						label="测评时间"
						width="160">
						<template slot-scope="scope">
							{{scope.row.addtime}}
						</template>
					</el-table-column>
					<el-table-column width="300" label="操作">
						<template slot-scope="scope">
							<el-button class="view" v-if=" isAuth('cepingJieguo','查看')" type="success" @click="viewDetails(scope.row)">
								<span class="icon iconfont icon-dagou" :style='{"margin":"0 2px","fontSize":"inherit","color":"inherit","height":"40px"}'></span>
								查看详情
							</el-button>
							<el-button class="del" v-if=" isAuth('cepingJieguo','删除')" type="danger" @click="deleteHandler(scope.row.id)">
								<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"inherit","height":"40px"}'></span>
								删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-pagination
				@size-change="sizeChangeHandle"
				@current-change="currentChangeHandle"
				:current-page="pageIndex"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="pageSize"
				:total="totalPage"
				:layout="layouts.join()"
				prev-text="上一页"
				next-text="下一页 "
				:hide-on-single-page="false"
				:style='{"padding":"0","margin":"20px 0 0","whiteSpace":"nowrap","color":"inherit","width":"100%","fontSize":"inherit","fontWeight":"500"}'
			></el-pagination>
		</template>
		
		<!-- 详情弹窗 -->
		<el-dialog 
			title="测评详情" 
			:visible.sync="detailDialogVisible"
			width="800px">
			<div v-if="detailData" class="detail-content">
				<el-descriptions :column="2" border>
					<el-descriptions-item label="工号">{{detailData.gonghao}}</el-descriptions-item>
					<el-descriptions-item label="姓名">{{detailData.xingming}}</el-descriptions-item>
					<el-descriptions-item label="手机">{{detailData.shouji}}</el-descriptions-item>
					<el-descriptions-item label="测评时间">{{detailData.addtime}}</el-descriptions-item>
					<el-descriptions-item label="A选项数量">{{detailData.aCount}}</el-descriptions-item>
					<el-descriptions-item label="B选项数量">{{detailData.bCount}}</el-descriptions-item>
					<el-descriptions-item label="C选项数量">{{detailData.cCount}}</el-descriptions-item>
					<el-descriptions-item label="测评结果">{{detailData.resultType}}</el-descriptions-item>
					<el-descriptions-item label="结果描述" :span="2">
						{{detailData.resultDescription}}
					</el-descriptions-item>
				</el-descriptions>
				
				<div style="margin-top: 20px;">
					<h4>答题详情</h4>
					<el-table :data="questionList" border style="margin-top: 10px;">
						<el-table-column prop="question" label="题号" width="80"></el-table-column>
						<el-table-column prop="title" label="题目" min-width="280"></el-table-column>
						<el-table-column prop="answer" label="答案" width="80" align="center"></el-table-column>
						<el-table-column prop="content" label="选项内容" min-width="200"></el-table-column>
					</el-table>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="detailDialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios'
	export default {
		data() {
			return {
				searchForm: {
					key: ""
				},
				form:{},
				dataList: [],
				pageIndex: 1,
				pageSize: 10,
				totalPage: 0,
				dataListLoading: false,
				dataListSelections: [],
				showFlag: true,
				layouts: ['prev', 'pager', 'next', 'jumper', '->', 'sizes', 'total'],
				detailDialogVisible: false,
				detailData: null,
				questionList: []
			}
		},
		created() {
		},
		mounted() {
			this.getDataList()
		},
		activated() {
			this.getDataList()
		},
		methods: {
			search() {
				this.pageIndex = 1;
				this.getDataList();
			},
			// 获取数据列表
			getDataList() {
				this.dataListLoading = true
				let params = {
					page: this.pageIndex,
					limit: this.pageSize,
					sort: 'addtime',
					order: 'desc'
				}
				
				// 搜索条件
				if(this.searchForm.gonghao) {
					params.gonghao = '%' + this.searchForm.gonghao + '%'
				}
				if(this.searchForm.xingming) {
					params.xingming = '%' + this.searchForm.xingming + '%'
				}
				if(this.searchForm.resultType) {
					params.resultType = '%' + this.searchForm.resultType + '%'
				}
				
				this.$http({
					url: "cepingJieguo/page",
					method: "get",
					params: params
				}).then(({ data }) => {
					if (data && data.code === 0) {
						this.dataList = data.data.list
						this.totalPage = data.data.total
					} else {
						this.dataList = []
						this.totalPage = 0
					}
					this.dataListLoading = false
				})
			},
			// 每页数
			sizeChangeHandle(val) {
				this.pageSize = val
				this.pageIndex = 1
				this.getDataList()
			},
			// 当前页
			currentChangeHandle(val) {
				this.pageIndex = val
				this.getDataList()
			},
			// 多选
			selectionChangeHandler(val) {
				this.dataListSelections = val
			},
			// 查看详情
			viewDetails(row) {
				console.log('===== 查看详情数据 =====')
				console.log('完整数据:', row)
				console.log('question1:', row.question1)
				console.log('question1Content:', row.question1Content)
				console.log('所有字段:', Object.keys(row))
				
				this.detailData = row
				
				// 题目列表
				const questionTitles = [
					'你日常行动是否需要借助辅助工具（如轮椅、拐杖等）？',
					'你是否具备某一项专业技能（如电脑操作、手工制作、文字编辑等）？',
					'你对工作环境的无障碍设施需求程度如何？',
					'你倾向的工作节奏是？',
					'你在与人沟通时，是否需要特殊辅助方式（如手语、文字交流等）？',
					'你能接受的工作时长（不含午休）是？',
					'你对工作地点的距离要求是？',
					'你是否有过工作或实习经历？',
					'面对工作中的困难，你通常会？',
					'你更倾向于从事哪类工作？'
				]
				
				// 组装答题详情
				this.questionList = []
				for(let i = 1; i <= 10; i++) {
					const answer = row['question' + i] || '-'
					const content = row['question' + i + 'Content'] || '-'
					console.log(`第${i}题 - 答案:${answer}, 内容:${content}`)
					this.questionList.push({
						question: `第${i}题`,
						title: questionTitles[i - 1],
						answer: answer,
						content: content
					})
				}
				
				this.detailDialogVisible = true
			},
			// 删除
			deleteHandler(id) {
				var ids = id ? [id] : this.dataListSelections.map(item => {
					return item.id
				})
				this.$confirm(`确定删除所选的${ids.length}条测评记录?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http({
						url: "cepingJieguo/delete",
						method: "post",
						data: ids
					}).then(({ data }) => {
						if (data && data.code === 0) {
							this.$message({
								message: '删除成功',
								type: 'success',
								duration: 1500
							})
							this.getDataList()
						} else {
							this.$message.error(data.msg)
						}
					})
				}).catch(() => {})
			}
		}
	}
</script>

<style lang="scss" scoped>
.center-form-pv ::v-deep .el-input__inner{
	background: rgba(255, 255, 255, 1);
	border-radius: 0px;
	padding: 0 12px;
	box-shadow: 0 0 0px rgba(75,123,219,.5);
	outline: none;
	color: #333;
	width: auto;
	border-width: 1px;
	border-style: solid;
	border-color: rgba(161,161,161,1);
	height: 40px;
}

.detail-content {
	padding: 0 20px;
	
	h4 {
		margin: 20px 0 10px;
		font-size: 16px;
		color: #333;
	}
}

/* 覆盖Element UI的success绿色为青蓝色 #56B2C6 */
.el-button--success {
    background-color: #56B2C6 !important;
    border-color: #56B2C6 !important;
}

.el-button--success:hover,
.el-button--success:focus {
    background-color: #68bdd2 !important;
    border-color: #68bdd2 !important;
}

.el-tag--success {
    background-color: rgba(86,178,198,.1) !important;
    border-color: rgba(86,178,198,.2) !important;
    color: #56B2C6 !important;
}

</style>

